import { render } from "./Statistic.vue?vue&type=template&id=9611d114"
import script from "./Statistic.vue?vue&type=script&lang=js"
export * from "./Statistic.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexandrbukhanov/Documents/Документы — MacBook Air — Alexandr/work/dt-teh/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__